import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface ArticleTagsProps {
  tags: string[];
}

const ArticleTags = ({ tags }: ArticleTagsProps) => (
  <div className="flex flex-wrap gap-2">
    {tags.map((tag) => (
      <Link
        key={tag}
        to={`/blog/tag/${encodeURIComponent(tag.toLowerCase().replace(/\s+/g, '-'))}`}
        onClick={() => window.scrollTo(0, 0)}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border text-xs font-heading font-medium text-muted-foreground hover:bg-primary/10 hover:text-primary hover:border-primary/20 transition-colors"
      >
        # {tag}
        <ArrowRight size={10} />
      </Link>
    ))}
  </div>
);

export default ArticleTags;
